module.exports = __webpack_public_path__ + "img/arrowback.1d59d4d2.svg";